<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      :title="'会议信息'"
      direction="rtl"
      :size="900"
      :before-close="() => close()"
      :close-on-press-escape="false"
      @close="close()"
    >
      <div class="drawer-main">
        <Main ref="main" :expoMeetingCode="expoMeetingCode" @close="close()" />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="close">
          {{ this.$l('INDEX.btn_close') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    expoMeetingCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 15px 32px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
